export const FormattingMixin = {
  methods: {
    eur (value, locale) {
      var l = (locale.split('-').length === 2) ? locale : `${locale.toLowerCase()}-${locale.toUpperCase()}`
      return new Intl.NumberFormat(l, { style: 'currency', currency: 'EUR' }).format(value).replace(/^(\D+)/, '$1 ')
    }
  }
}
